var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { IconButton, Link, Menu, MenuItem } from '@mui/material';
import React from 'react';
export const MenuIconButton = (props) => {
    var _a, _b, _c, _d;
    const [anchorEl, setAnchorEl] = React.useState();
    const handleClick = (event) => {
        if (props.stopPropagationOnClick) {
            event.stopPropagation();
        }
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (event) => {
        if (props.stopPropagationOnClick) {
            event.stopPropagation();
        }
        setAnchorEl(undefined);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(IconButton, { size: (_a = props.size) !== null && _a !== void 0 ? _a : props.iconSize, color: (_b = props.color) !== null && _b !== void 0 ? _b : 'inherit', disabled: props.disabled, tabIndex: props.tabIndex, sx: props.sx, onClick: handleClick, onPointerDown: props.stopPropagationOnPointerDown ? (event) => event.stopPropagation() : undefined, "data-test": props['data-test'], "aria-label": props['aria-label'], "aria-haspopup": 'menu', "aria-expanded": !!anchorEl },
            props.icon,
            props.children),
        React.createElement(Menu, { anchorEl: anchorEl, open: !!anchorEl, anchorOrigin: { horizontal: (_c = props.anchor) !== null && _c !== void 0 ? _c : 'left', vertical: 'bottom' }, transformOrigin: { horizontal: (_d = props.anchor) !== null && _d !== void 0 ? _d : 'left', vertical: 'top' }, onClose: handleClose, onPointerDown: props.stopPropagationOnPointerDown ? (event) => event.stopPropagation() : undefined }, props.menuItems.map((_a) => {
            var { onClick } = _a, menuItem = __rest(_a, ["onClick"]);
            return menuItem.href ? (React.createElement(MenuItem, { key: menuItem.label, onClick: (event) => {
                    if (onClick) {
                        event.preventDefault();
                        onClick();
                    }
                    handleClose(event);
                }, disabled: menuItem.disabled, "data-test": menuItem['data-test'], "aria-label": menuItem['aria-label'] },
                React.createElement(Link, { sx: {
                        color: 'inherit',
                        '&:hover': { textDecoration: 'inherit' },
                        display: 'block',
                        width: '100%',
                        height: '100%',
                    }, href: menuItem.href }, menuItem.label))) : (React.createElement(MenuItem, { key: menuItem.label, onClick: (event) => {
                    if (onClick) {
                        event.preventDefault();
                        onClick();
                    }
                    handleClose(event);
                }, disabled: menuItem.disabled, "data-test": menuItem['data-test'], "aria-label": menuItem['aria-label'] }, menuItem.label));
        }))));
};
